import { useEffect } from 'react';

/**
 * Discourages casual use of browser inspection shortcuts.
 * This is a UI deterrent only; client-side code cannot be made inaccessible.
 */
export function InspectDeterrent() {
  useEffect(() => {
    const preventContextMenu = (event: MouseEvent) => event.preventDefault();

    const preventInspectShortcuts = (event: KeyboardEvent) => {
      const key = event.key.toLowerCase();
      const modifier = event.ctrlKey || event.metaKey;
      const inspectShortcut = modifier && event.shiftKey && ['c', 'i', 'j'].includes(key);
      const viewSourceShortcut = modifier && key === 'u';

      if (event.key === 'F12' || inspectShortcut || viewSourceShortcut) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('contextmenu', preventContextMenu);
    document.addEventListener('keydown', preventInspectShortcuts, true);

    return () => {
      document.removeEventListener('contextmenu', preventContextMenu);
      document.removeEventListener('keydown', preventInspectShortcuts, true);
    };
  }, []);

  return null;
}
